import { action } from "satcheljs";

const resetUniqueSubshiftStore = action(
    "resetUniqueSubshiftStore", () => ({})
);

export default resetUniqueSubshiftStore;
